import { Plus, Trash2, ArrowUp, ArrowDown, Award, GripVertical } from "lucide-react";
import { Input, Area, ImageInput } from "./fields";
import { useDragReorder } from "../../lib/useDragReorder";

const uid = () => `pm-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;

// Éditeur structuré du palmarès (récompenses). Réutilisé pour l'édition en cours et chaque édition archivée.
export const AdminPalmares = ({ items = [], onChange, testid = "admin-palmares" }) => {
  const list = items || [];
  const patch = (i, p) => { const c = [...list]; c[i] = { ...c[i], ...p }; onChange(c); };
  const move = (i, dir) => { const j = i + dir; if (j < 0 || j >= list.length) return; const c = [...list]; [c[i], c[j]] = [c[j], c[i]]; onChange(c); };
  const add = () => onChange([...list, { id: uid(), award: "", film: "", laureate: "", year: "", note: "", image: "" }]);
  const { handleProps, itemProps, overIndex } = useDragReorder(list, onChange);

  return (
    <div className="space-y-4" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] tracking-[0.25em] uppercase text-electric flex items-center gap-2"><Award size={14} /> Palmarès (récompenses)</span>
        <button onClick={add} data-testid={`${testid}-add`} className="inline-flex items-center gap-2 text-xs text-white/70 hover:text-electric"><Plus size={14} /> Ajouter une récompense</button>
      </div>
      {list.length === 0 && <p className="text-secondary2 text-sm">Aucune récompense. Ajoutez les lauréats (Grand Prix, Meilleur documentaire, Prix du public…).</p>}
      {list.map((it, i) => (
        <div key={it.id || i} data-testid={`${testid}-item-${i}`} {...itemProps(i)}
          className={`rounded-lg border p-4 bg-[#0a0a0a] space-y-3 transition-colors ${overIndex === i ? "border-electric ring-1 ring-electric/60" : "border-white/10"}`}>
          <div className="flex items-center justify-between">
            <span className="text-[10px] text-secondary2 inline-flex items-center gap-2">
              <button {...handleProps(i)} title="Glisser pour réordonner" data-testid={`${testid}-drag-${i}`} className="cursor-grab active:cursor-grabbing text-white/30 hover:text-electric touch-none"><GripVertical size={14} /></button>
              #{i + 1}
            </span>
            <div className="flex items-center gap-2">
              <button onClick={() => move(i, -1)} data-testid={`${testid}-up-${i}`} className="text-white/40 hover:text-electric"><ArrowUp size={14} /></button>
              <button onClick={() => move(i, 1)} data-testid={`${testid}-down-${i}`} className="text-white/40 hover:text-electric"><ArrowDown size={14} /></button>
              <button onClick={() => onChange(list.filter((_, x) => x !== i))} data-testid={`${testid}-delete-${i}`} className="text-red-400/70 hover:text-red-400"><Trash2 size={14} /></button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <Input label="Prix / Catégorie" value={it.award} onChange={(v) => patch(i, { award: v })} placeholder="Grand Prix" />
            <Input label="Film / Œuvre" value={it.film} onChange={(v) => patch(i, { film: v })} />
            <Input label="Lauréat / Réalisateur" value={it.laureate} onChange={(v) => patch(i, { laureate: v })} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-[120px_1fr] gap-3">
            <Input label="Année (opt.)" value={it.year} onChange={(v) => patch(i, { year: v })} />
            <Area label="Mention (opt.)" value={it.note} onChange={(v) => patch(i, { note: v })} rows={2} />
          </div>
          <ImageInput label="Visuel (affiche / photo, opt.)" value={it.image} onChange={(v) => patch(i, { image: v })} />
        </div>
      ))}
    </div>
  );
};
